import React from 'react';
import useSpecificSubjectContext from './context';
import useNavigatorContext from './navigator-context';
import { IfToggleIsOpen } from '~/components/toggle/toggle';
import ToggleControlBar from '~/components/toggle/toggle-control-bar';
import ArrowToggle from '~/components/toggle/arrow-toggle';
import AccordionGroup from '~/components/accordion-group/accordion-group';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { assertDefined } from '~/helpers/data';
import './navigator.scss';
const LEARN_MORE_IDS = ['blog-posts', 'webinars', 'learn'];
export default function Navigator({ subject }) {
    return (React.createElement("div", { className: "navigator" },
        React.createElement("div", { style: { position: 'sticky', top: '9rem' } },
            React.createElement("nav", { "aria-labelledby": "category-section-links-header" },
                React.createElement("img", { src: subject.icon, role: "presentation" }),
                React.createElement("h2", { id: "category-section-links-header" },
                    React.createElement(FormattedMessage, { id: "subject.categoryTitle", defaultMessage: "{subjectName} Book Categories", values: { subjectName: subject.html } })),
                React.createElement(CategorySectionLinks, null)),
            React.createElement("nav", { "aria-labelledby": "other-section-links-header" },
                React.createElement("h2", { id: "other-section-links-header" },
                    React.createElement(FormattedMessage, { id: "subject.learnMoreTitle", defaultMessage: "Learn more" })),
                React.createElement(OtherSectionLinks, null)))));
}
function CategorySectionLinks() {
    const { categories } = useSpecificSubjectContext();
    return (React.createElement(React.Fragment, null, categories.map(([c]) => (React.createElement(CategoryLink, { category: c, key: c })))));
}
function CategoryLink({ category }) {
    return React.createElement(SectionLink, { id: category, text: category });
}
function SectionLink({ id, text }) {
    const { currentId, registerId, unregisterId, goTo } = useNavigatorContext();
    const onClick = React.useCallback((e) => {
        e.preventDefault();
        goTo(id);
    }, [id, goTo]);
    React.useEffect(() => {
        registerId(id);
        return () => unregisterId(id);
    }, [registerId, unregisterId, id]);
    return (React.createElement(Link, { to: { hash: `#${id}` }, replace: true, "aria-current": id === currentId, onClick: onClick }, text));
}
function OtherSectionLinks() {
    const { learnMoreAboutBooks, learnMoreBlogPosts, learnMoreWebinars } = useSpecificSubjectContext();
    // If one is defined, they all are
    if (!learnMoreAboutBooks) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(SectionLink, { id: "blog-posts", text: assertDefined(learnMoreBlogPosts) }),
        React.createElement(SectionLink, { id: "webinars", text: assertDefined(learnMoreWebinars) }),
        React.createElement(SectionLink, { id: "learn", text: learnMoreAboutBooks })));
}
function useAccordionItems(subjectName) {
    const intl = useIntl();
    return [
        {
            title: intl.formatMessage({ id: 'subject.categoryTitle' }, { subjectName }),
            contentComponent: React.createElement(CategorySectionLinks, null)
        },
        {
            title: intl.formatMessage({ id: 'subject.learnMoreTitle' }),
            contentComponent: React.createElement(OtherSectionLinks, null)
        }
    ];
}
export function JumpToSection({ subjectName }) {
    return (React.createElement("div", { className: "jump-to-section" },
        React.createElement(ToggleControlBar, { Indicator: ArrowToggle },
            React.createElement("div", null, "Jump to section")),
        React.createElement(IfToggleIsOpen, null,
            React.createElement(AccordionGroup, { items: useAccordionItems(subjectName), noScroll: true }))));
}
